import React from 'react';
import styles from './skeletonLoader.module.css';

/** Stand-in for the canvas while the board loads: a shimmer filling the card. */
const Loader = () => (
  <div className={styles.page} role="status" aria-label="Loading board">
    <span className={styles.shimmer} />
  </div>
);

export default Loader;
